import { AulaReduxAction } from '../../types/state';
import {
  CLASSROOM_DELETE_FOLDER,
  CLASSROOM_MODULE_DELETE_SECTION,
} from '../actions';
import { isLocalId } from '../../utils/localId';
import { Material } from '../types';

const discardUnsavedLocalMaterials =
  (): AulaReduxAction => (dispatch, getState) => {
    const state = getState();
    const materials = state?.data?.materials || {};

    if (Object.keys(materials).length === 0) {
      return;
    }

    Object.values(materials).forEach((material: Material) => {
      // if material id is local, it means it has not been saved to the backend and can be discarded.
      if (!isLocalId(material.id)) {
        return;
      }

      // if local material is a folder
      if (material.isFolder) {
        dispatch({
          type: CLASSROOM_DELETE_FOLDER,
          status: 'success',
          payload: { materialId: material.id },
        });
        return;
      }

      dispatch({
        type: CLASSROOM_MODULE_DELETE_SECTION,
        status: 'success',
        payload: { materialId: material.id },
      });
    });
  };

export default discardUnsavedLocalMaterials;
